import { EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface SkuPriceConfigProps {
  skuConfig: any;
  proValue: string;
  currentSkinName: string;
  onProChange: (value: string) => void;
  onHiddenChange: (checked: boolean) => void;
}

export function SkuPriceConfig({
  skuConfig,
  proValue,
  currentSkinName,
  onProChange,
  onHiddenChange,
}: SkuPriceConfigProps) {
  return (
    <>
      {/* 隐藏选项 */}
      <div className="flex items-center justify-between p-3 rounded-lg border bg-muted/30">
        <div className="flex items-center gap-2">
          <EyeOff className="h-4 w-4 text-muted-foreground" />
          <div>
            <Label className="text-sm">App 中隐藏</Label>
            <p className="text-[10px] text-muted-foreground">
              勾选后该 SKU 在 App 中不显示
            </p>
          </div>
        </div>
        <Switch checked={!!skuConfig.hidden} onCheckedChange={onHiddenChange} />
      </div>

      {/* 价格 */}
      <div className={cn("space-y-2", skuConfig.hidden && "opacity-50")}>
        <Label className="text-xs">
          价格 (pro)
          {skuConfig.hidden && (
            <span className="text-muted-foreground ml-2">
              （隐藏 SKU 无法设置价格）
            </span>
          )}
        </Label>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min={0}
            value={proValue}
            onChange={(e) => onProChange(e.target.value)}
            className="text-sm"
            placeholder="0 = 免费"
            disabled={!!skuConfig.hidden}
          />
          {parseInt(proValue) === 0 && (
            <Badge variant="secondary" className="shrink-0">
              免费
            </Badge>
          )}
          {parseInt(proValue) > 0 && (
            <Badge className="shrink-0 bg-amber-500">¥{proValue}</Badge>
          )}
        </div>
        {/* 快捷价格按钮 */}
        <div className="flex flex-wrap gap-1.5">
          {[0, 100, 200, 500, 1000, 2000].map((price) => (
            <Button
              key={price}
              variant={parseInt(proValue) === price ? "default" : "outline"}
              size="sm"
              className={cn(
                "h-7 px-2.5 text-xs",
                parseInt(proValue) === price &&
                  price > 0 &&
                  "bg-amber-500 hover:bg-amber-600",
              )}
              onClick={() => onProChange(price.toString())}
              disabled={!!skuConfig.hidden}
            >
              {price === 0 ? "免费" : `¥${price}`}
            </Button>
          ))}
        </div>
        <p className="text-[10px] text-muted-foreground">
          点击快捷按钮或手动输入价格
        </p>
      </div>
    </>
  );
}
